import React, { ComponentProps, useState } from 'react'

import { Checkbox } from '@/shared/components/Checkbox/Checkbox'
import { FormControlLabel } from '@mui/material'

type BulkEditCheckboxProps = ComponentProps<typeof Checkbox> & {
  name: string
  label?: string
}

export const BulkEditCheckbox: React.FC<BulkEditCheckboxProps> = ({ 
  name,
  label = 'Update field',
  ...props
}: BulkEditCheckboxProps) => {
  const [checked, setChecked] = useState(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
  }

  return (
    <FormControlLabel
      control={
        <Checkbox
          size="small"
          checked={checked}
          onChange={handleChange}
          className="cbBulk"
          name={name}
          {...props}
        />
      }
      label={label}
    />
  )
}